// extracted by mini-css-extract-plugin
module.exports = {"container":"SwipeCardCustom_container__24mAA","card":"SwipeCardCustom_card__2ku5e","subtitle":"SwipeCardCustom_subtitle__2EOvG"};